const _temp0 = require("./Black School Children.png");
const _temp1 = require("./Bus Tour Group.png");
const _temp2 = require("./Cars and People at Overlook.png");
const _temp3 = require("./Civil Rights March DC.png");
const _temp4 = require("./Comfort Station.png");
const _temp5 = require("./Early Shenandoah View.png");
const _temp6 = require("./Family Staying in Lewis Mountain Cabin 1941.png");
const _temp7 = require("./Freedmen's Bureau Act of 1865.png");
const _temp8 = require("./Girl at Little Rock.png");
const _temp9 = require("./Green Book 1959 Edition.png");
const _temp10 = require("./Horseback Riding.png");
const _temp11 = require("./Johnson Civil Rights Act.png");
const _temp12 = require("./Lewis Mountain Negro Area Sign.png");
const _temp13 = require("./Lewis Mountain Picnic Grounds for Negroes Sign.png");
const _temp14 = require("./Lodge Brochure 1969.png");
const _temp15 = require("./Looking at Mountain View.png");
const _temp16 = require("./Map of Segregated Areas.png");
const _temp17 = require("./North Entrance at Shenandoah 1939.png");
const _temp18 = require("./NPS Director Albright 1929-1933.png");
const _temp19 = require("./Park Ranger 1949.png");
const _temp20 = require("./Pinnacles Picnic Ground.png");
const _temp21 = require("./Postcard of Cars at Overlook.png");
const _temp22 = require("./Shenandoah in 1939 Panorama.png");
const _temp23 = require("./Skyline Drive 1972.png");
const _temp24 = require("./Skyline Drive North Entrance Sign.png");
const _temp25 = require("./Superintendent Lassiter.png");
const _temp26 = require("./Tourists Sitting in Grass.png");
const _temp27 = require("./White Women in Bathroom.png");
module.exports = {
  "Black School Children": _temp0,
  "Bus Tour Group": _temp1,
  "Cars and People at Overlook": _temp2,
  "Civil Rights March DC": _temp3,
  "Comfort Station": _temp4,
  "Early Shenandoah View": _temp5,
  "Family Staying in Lewis Mountain Cabin 1941": _temp6,
  "Freedmen's Bureau Act of 1865": _temp7,
  "Girl at Little Rock": _temp8,
  "Green Book 1959 Edition": _temp9,
  "Horseback Riding": _temp10,
  "Johnson Civil Rights Act": _temp11,
  "Lewis Mountain Negro Area Sign": _temp12,
  "Lewis Mountain Picnic Grounds for Negroes Sign": _temp13,
  "Lodge Brochure 1969": _temp14,
  "Looking at Mountain View": _temp15,
  "Map of Segregated Areas": _temp16,
  "North Entrance at Shenandoah 1939": _temp17,
  "NPS Director Albright 1929-1933": _temp18,
  "Park Ranger 1949": _temp19,
  "Pinnacles Picnic Ground": _temp20,
  "Postcard of Cars at Overlook": _temp21,
  "Shenandoah in 1939 Panorama": _temp22,
  "Skyline Drive 1972": _temp23,
  "Skyline Drive North Entrance Sign": _temp24,
  "Superintendent Lassiter": _temp25,
  "Tourists Sitting in Grass": _temp26,
  "White Women in Bathroom": _temp27
}